export default [
    { value: null, text: 'Todos' },
    { value: 'GseTef', text: 'GseTef' },
    { value: 'GSPayments', text: 'GSPayments' },
    { value: 'Aditum', text: 'Aditum' }
]